var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUniversalRetailer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Shopping-Basket-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shopping Basket 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.63h-19a0.5 0.5 0 0 0 -0.39 0.18 0.5 0.5 0 0 0 -0.1 0.41l1.28 6.41a2.35 2.35 0 0 0 2.48 1.5h12.46a2.35 2.35 0 0 0 2.48 -1.5L22 15.22a0.5 0.5 0 0 0 -0.1 -0.41 0.5 0.5 0 0 0 -0.4 -0.18Zm-13.75 5.5v-2.5a0.75 0.75 0 0 1 1.5 0v2.5a0.75 0.75 0 0 1 -1.5 0Zm8.5 0a0.75 0.75 0 0 1 -1.5 0v-2.5a0.75 0.75 0 1 1 1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.13a2 2 0 0 0 -2 -2h-1.86a0.25 0.25 0 0 1 -0.23 -0.13l-3.27 -7.38a1.25 1.25 0 1 0 -2.28 1l2.73 6.14a0.29 0.29 0 0 1 0 0.24 0.27 0.27 0 0 1 -0.21 0.12H7A0.27 0.27 0 0 1 6.77 9a0.26 0.26 0 0 1 0 -0.24l2.86 -6.1a1.25 1.25 0 1 0 -2.26 -1.07L3.89 9a0.25 0.25 0 0 1 -0.22 0.15H2a2 2 0 0 0 0 4h20a2 2 0 0 0 2 -2.02Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUniversalRetailer);
export default ForwardRef;